export { default } from '@shikijs/langs/scss'
